/** description_config admin API client (Gutachterliche Config: Beschreibungs-Texte) */
import axios from 'axios'
import { attachAuth } from '../../lib/apiAuth'

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8899'
const api = axios.create({ baseURL: `${API_BASE}/admin/description-config`, headers: { 'Content-Type': 'application/json' } })

export interface DescriptionConfigOut {
  key: string
  name: string
  description?: string | null
  is_active: boolean
  version: number
  config: any
}

export async function getDescriptionConfig(): Promise<DescriptionConfigOut> {
  return (await api.get('')).data
}

export async function saveDescriptionConfig(body: { name?: string; description?: string; config: any }): Promise<{ ok: boolean }> {
  return (await api.put('', body)).data
}

/** Ein Bereich der Lagedaten-Tabelle = eine Textbox im Editor (Reihenfolge = Layout-Reihenfolge) */
export interface DescriptionBereich {
  key: string
  titel: string
  rating_key?: string | null
}

export interface DescriptionStructure {
  makro: DescriptionBereich[]
  mikro: DescriptionBereich[]
}

/** Einsetzbare Variable inkl. Untervarianten und Beispielwert für den Picker */
export interface DescriptionVariable {
  name: string
  label: string
  bereich_key: string
  bereich_titel: string
  untervarianten: string[]
  beispiel?: string | null
  nur_gruppierung: boolean
}

export interface DescriptionVariables {
  makro: DescriptionVariable[]
  mikro: DescriptionVariable[]
}

/** Schlüssel: "<ebene>.<bereich_key>" → Liste unbekannter Variablennamen */
export type DescriptionWarnings = Record<string, string[]>

export async function getDescriptionStructure(): Promise<DescriptionStructure> {
  return (await api.get('/structure')).data
}

export async function getDescriptionVariables(ags: string): Promise<DescriptionVariables> {
  return (await api.get('/variables', { params: { ags } })).data
}

export async function getDescriptionWarnings(ags: string): Promise<DescriptionWarnings> {
  return (await api.get('/warnings', { params: { ags } })).data
}

export async function getDescriptionPreview(ags: string): Promise<any> {
  return (await api.get('/preview', { params: { ags } })).data
}

/** Config-Ebene Export/Import + Voraussetzungen-Prüfung (Gutachten-Bundle) */
const gutachtenApi = axios.create({ baseURL: `${API_BASE}/admin/gutachten`, headers: { 'Content-Type': 'application/json' } })

export async function exportBundle(): Promise<any> {
  return (await gutachtenApi.get('/export')).data
}

export async function importBundle(bundle: any, dryRun: boolean): Promise<any> {
  return (await gutachtenApi.post('/import', bundle, { params: { dry_run: dryRun } })).data
}

export async function getRequirements(): Promise<any> {
  return (await gutachtenApi.get('/requirements')).data
}

// Basic-Auth-Header + 401-Behandlung (optionaler Schutz, v0.3.8)
attachAuth(api)
attachAuth(gutachtenApi)
